import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedUiButtonModule} from "@snelstart/ui-button";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-div-inhoudingsplichtige',
  standalone: true,
    imports: [CommonModule, SharedUiButtonModule],
  templateUrl: './tekst-inhoudingsplichtige.component.html',
  styleUrl: './tekst-inhoudingsplichtige.component.scss',
})
export class TekstInhoudingsplichtigeComponent {}
